/**
 * APP 商城登录、绑邮箱提醒、检查登录（R66 + Legacy）。
 * 非 APP WebView 直接 return。商城不强制登录；个人中心失败则跳账户中心登录页。
 */
(function () {
  'use strict';

  if (window.__rrMallAuthInitialized__) return;
  window.__rrMallAuthInitialized__ = true;

  /** 仅换号对账，不参与「有邮箱 → 自动登录」 */
  var SWITCH_KEY = '__rr_r66_app_switch_identity__';
  var PENDING_KEY = '__rr_r66_pending_relogin__';
  var BIND_RETURN_KEY = '__rr_r66_bind_email_return__';
  var BIND_RETURN_MIN_AGE_MS = 400;
  var DISMISS_UNTIL_KEY = '__rr_bind_email_dismissed_until__';
  var MALL_ID_KEY = '__rr_mall_token_id__';
  var DISMISS_MS = 3 * 24 * 60 * 60 * 1000;
  /** 本地测无邮箱游客：true = 剥掉 getUserInfo.email 并按未登录走。测完必须改回 false。不写 localStorage。 */
  var MOCK_NO_EMAIL = false;
  var BRIDGE_TIMEOUT_MS = 5000;
  var BIND_EMAIL_RETRY = 8;
  var BIND_EMAIL_RETRY_MS = 500;
  var PENDING_POLL_MS = 1200;
  var PENDING_POLL_MAX_MS = 30000;
  var LOGIN_LOADING_MIN_MS = 2500;
  var SWITCH_RECHECK_MS = 500;
  var SWITCH_RECHECK_MAX = 4;
  /** getUserInfo 刚回调就打 getMallTokenV2，原生同页第二次协议经常不回调 */
  var NATIVE_SETTLE_MS = 300;
  var MALL_TOKEN_RETRY = 1;

  var cfg = window.__rrMallAuthConfig || {};
  var i18n = cfg.i18n || {};
  var whitelist = parseWhitelist(cfg.whitelistRaw);
  var isAccountLayout = !!cfg.isAccountLayout;
  var path = typeof cfg.path === 'string' ? cfg.path : '';

  function isMallHomePath() {
    var p = '';
    try {
      p = window.location.pathname || '';
    } catch (e) {}
    if (!p) p = path;
    p = String(p).replace(/\/+$/, '') || '/';
    return /\/pages\/app-store$/i.test(p);
  }

  var _dismissHandler = null;
  var _bindHandler = null;
  var _allowOnce = false;
  var _watchInFlight = false;
  var _watchQueued = false;
  var _skipPendingRetry = false;
  var _watchFromResume = false;
  var _resumeFromBindEmail = false;
  /** iOS 去原生（换号 / 绑邮箱）常不打 visibilitychange，靠 blur 后再 focus/pageshow 补一次 */
  var _needResumeWatch = false;
  var _resumeEventsReady = false;
  var _modalInited = false;
  var _checkoutGate = null;
  var _userInfoCache = undefined;
  var _userInfoInflight = null;
  var _userInfoGen = 0;
  var _resumeTimer = null;
  var _autoLoginInFlight = false;
  var _mallTokenInflight = null;
  var _legacyTokenInflight = null;
  var _mallLoginNavigating = false;
  var _pendingPollTimer = null;
  var _pendingPollUntil = 0;
  var _loginLoadingEl = null;
  var _loginLoadingShownAt = 0;
  var _loginLoadingHideTimer = null;
  var _switchRecheckLeft = 0;
  var _switchRecheckTimer = null;
  var _lastNativeCallAt = 0;

  function authLog() {
    try {
      var args = ['[AppMallAuth]'];
      for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
      console.log.apply(console, args);
    } catch (e) {}
  }

  function ensureMallLoginLoadingStyle() {
    if (document.getElementById('rr-mall-auth-loading-style')) return;
    var style = document.createElement('style');
    style.id = 'rr-mall-auth-loading-style';
    style.textContent =
      '#rr-mall-auth-loading{position:fixed;inset:0;z-index:10050;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.92);}' +
      '#rr-mall-auth-loading .rr-mall-auth-loading__spinner{width:42px;height:42px;border:2px solid #e6e6e6;border-top-color:#161616;border-radius:50%;animation:rr-mall-auth-spin .9s linear infinite;}' +
      '@keyframes rr-mall-auth-spin{to{transform:rotate(360deg);}}';
    document.head.appendChild(style);
  }

  function showMallLoginLoading() {
    window.__rrMallAuthHoldPageLoading = true;
    if (!_loginLoadingShownAt) _loginLoadingShownAt = Date.now();
    var page = document.querySelector('.as-page-loading');
    if (page) {
      page.classList.remove('hidden');
      page.style.display = '';
      page.style.visibility = 'visible';
      _loginLoadingEl = page;
      return;
    }
    if (document.getElementById('rr-mall-auth-loading')) return;
    ensureMallLoginLoadingStyle();
    var wrap = document.createElement('div');
    wrap.id = 'rr-mall-auth-loading';
    wrap.setAttribute('aria-busy', 'true');
    wrap.innerHTML = '<div class="rr-mall-auth-loading__spinner"></div>';
    document.body.appendChild(wrap);
    _loginLoadingEl = wrap;
  }

  function hideMallLoginLoading() {
    window.__rrMallAuthHoldPageLoading = false;
    if (_loginLoadingHideTimer) {
      clearTimeout(_loginLoadingHideTimer);
      _loginLoadingHideTimer = null;
    }
    var shownAt = _loginLoadingShownAt;
    _loginLoadingShownAt = 0;
    function remove() {
      var el = _loginLoadingEl;
      _loginLoadingEl = null;
      if (!el) {
        var leftover = document.querySelector('.as-page-loading');
        if (leftover) leftover.remove();
        return;
      }
      el.classList.add('hidden');
      if (el.parentNode) el.parentNode.removeChild(el);
    }
    var wait = shownAt ? LOGIN_LOADING_MIN_MS - (Date.now() - shownAt) : 0;
    if (wait > 0) _loginLoadingHideTimer = setTimeout(remove, wait);
    else remove();
  }

  function isAppWebView() {
    try {
      if (typeof window.__rrMallIsAppWebView__ === 'function') {
        return !!window.__rrMallIsAppWebView__();
      }
    } catch (e) {}
    return /RR_MALL_(Android|IOS|Harmony)/i.test(navigator.userAgent || '');
  }

  function isIosAppWebView() {
    var ua = navigator.userAgent || '';
    if (/RR_MALL_IOS/i.test(ua)) return true;
    if (/iPhone|iPod|iPad/i.test(ua)) return true;
    try {
      if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return true;
    } catch (e) {}
    return false;
  }

  function isMockNoEmail() {
    return !!MOCK_NO_EMAIL;
  }

  /** Shopify customer 判定；无邮箱 mock 时按未登录，方便测游客链路 */
  function getIsCustomer() {
    if (isMockNoEmail()) return false;
    return !!cfg.isCustomer;
  }

  function stripEmailFromUser(user) {
    if (user == null || typeof user !== 'object') return user;
    var next = {};
    Object.keys(user).forEach(function (key) {
      if (key !== 'email') next[key] = user[key];
    });
    return next;
  }

  function installGetUserInfoMock() {
    if (window.__rrMockNoEmailInstalled__) return;
    var bridge = window.AppWebBridge;
    if (!bridge || typeof bridge.getUserInfo !== 'function') return;
    window.__rrMockNoEmailInstalled__ = true;
    var orig = bridge.getUserInfo;
    bridge.getUserInfo = function () {
      return orig.apply(bridge, arguments).then(function (user) {
        if (!isMockNoEmail()) return user;
        return stripEmailFromUser(user);
      });
    };
  }

  function parseWhitelist(raw) {
    if (raw == null || raw === '') return [];
    return String(raw)
      .split(/\r?\n/)
      .map(function (line) {
        return line.replace(/^\s+|\s+$/g, '').replace(/\/+$/, '');
      })
      .filter(function (line) {
        return line.length > 0 && line.charAt(0) !== '#';
      });
  }

  function pathMatchesWhitelist() {
    var current = path.replace(/\/+$/, '') || '/';
    for (var i = 0; i < whitelist.length; i++) {
      var item = whitelist[i];
      if (current === item || current.indexOf(item + '/') === 0) return true;
    }
    return false;
  }

  function extractMallLoginToken(res) {
    if (res == null) return null;
    if (typeof res === 'string' && res.length > 0) return res;
    if (typeof res === 'object') {
      if (res.token) return res.token;
      if (res.data && res.data.token) return res.data.token;
      if (res.result && res.result.token) return res.result.token;
    }
    return null;
  }

  var _bindEmailPerf = null;

  function startBindEmailPerf(source) {
    _bindEmailPerf = {
      source: source,
      path: path,
      t0: Date.now(),
      last: Date.now(),
      steps: []
    };
    console.log('[BindEmailPerf] START', source, path);
  }

  function markBindEmailPerf(step, extra) {
    if (!_bindEmailPerf) return;
    var now = Date.now();
    var row = {
      step: step,
      dtMs: now - _bindEmailPerf.last,
      totalMs: now - _bindEmailPerf.t0
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        row[key] = extra[key];
      });
    }
    _bindEmailPerf.last = now;
    _bindEmailPerf.steps.push(row);
    if (extra) {
      console.log('[BindEmailPerf]', step, '+' + row.dtMs + 'ms', 'total ' + row.totalMs + 'ms', extra);
    } else {
      console.log('[BindEmailPerf]', step, '+' + row.dtMs + 'ms', 'total ' + row.totalMs + 'ms');
    }
  }

  function finishBindEmailPerf(outcome) {
    if (!_bindEmailPerf) return;
    markBindEmailPerf('done', { outcome: outcome });
    var slowest = null;
    for (var i = 0; i < _bindEmailPerf.steps.length; i++) {
      var item = _bindEmailPerf.steps[i];
      if (item.step === 'done') continue;
      if (!slowest || item.dtMs > slowest.dtMs) slowest = item;
    }
    console.log('[BindEmailPerf] SUMMARY', {
      source: _bindEmailPerf.source,
      path: _bindEmailPerf.path,
      outcome: outcome,
      totalMs: Date.now() - _bindEmailPerf.t0,
      slowest: slowest ? slowest.step + ' ' + slowest.dtMs + 'ms' : null,
      steps: _bindEmailPerf.steps
    });
    _bindEmailPerf = null;
  }

  function persistMallTokenId(id) {
    if (id == null || id === '') return;
    var value = String(id);
    if (
      window.rrMallContainerQuery &&
      typeof window.rrMallContainerQuery.persistMallIdIfChanged === 'function'
    ) {
      window.rrMallContainerQuery.persistMallIdIfChanged(value);
      return;
    }
    try {
      var prev = localStorage.getItem(MALL_ID_KEY);
      if (String(prev) === value) return;
      localStorage.setItem(MALL_ID_KEY, value);
    } catch (e) {}
  }

  function resolveMallTokenId() {
    var raw = null;
    var source = 'none';
    try {
      raw = new URLSearchParams(window.location.search).get('id');
      if (raw != null && raw !== '') source = 'url';
    } catch (e) {}
    if (raw == null || raw === '') {
      if (
        window.rrMallContainerQuery &&
        typeof window.rrMallContainerQuery.getPersistedMallId === 'function'
      ) {
        var localId = window.rrMallContainerQuery.getPersistedMallId();
        if (localId != null) {
          raw = String(localId);
          source = 'localStorage';
        }
      }
    }
    if (raw == null || raw === '') {
      try {
        raw = localStorage.getItem(MALL_ID_KEY);
        if (raw != null && raw !== '') source = 'localStorage';
      } catch (e) {}
    }
    if (raw == null || raw === '') {
      try {
        raw = sessionStorage.getItem(MALL_ID_KEY);
        if (raw != null && raw !== '') source = 'session:mall-id';
      } catch (e) {}
    }
    if (raw != null && raw !== '') {
      var n = parseInt(raw, 10);
      if (!isNaN(n)) {
        persistMallTokenId(n);
        return { id: n, source: source };
      }
    }
    return { id: null, source: source };
  }

  function getMallTokenV2IdFromUrl() {
    return resolveMallTokenId().id;
  }

  function hasPendingRelogin() {
    try {
      var pending = localStorage.getItem(PENDING_KEY);
      return pending === '0' || pending === '1';
    } catch (e) {
      return false;
    }
  }

  function markBindEmailReturn() {
    try {
      sessionStorage.setItem(BIND_RETURN_KEY, String(Date.now()));
    } catch (e) {}
  }

  function clearBindEmailReturn() {
    try {
      sessionStorage.removeItem(BIND_RETURN_KEY);
    } catch (e) {}
  }

  function peekBindEmailReturn() {
    try {
      var raw = sessionStorage.getItem(BIND_RETURN_KEY);
      if (!raw) return false;
      var t = parseInt(raw, 10);
      if (isNaN(t)) return false;
      if (Date.now() - t < BIND_RETURN_MIN_AGE_MS) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function beginBindEmailReturnIfNeeded() {
    if (_resumeFromBindEmail) return true;
    if (!peekBindEmailReturn()) return false;
    clearBindEmailReturn();
    _resumeFromBindEmail = true;
    authLog('resume from bind email');
    return true;
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function markNativeCallSettled() {
    _lastNativeCallAt = Date.now();
  }

  function waitAfterNativeCall() {
    var elapsed = _lastNativeCallAt ? Date.now() - _lastNativeCallAt : NATIVE_SETTLE_MS;
    var wait = elapsed >= NATIVE_SETTLE_MS ? 0 : NATIVE_SETTLE_MS - elapsed;
    if (wait <= 0) return Promise.resolve();
    authLog('native settle wait', wait + 'ms');
    return delay(wait);
  }

  function isBridgeTimeout(err) {
    return !!(err && err.message === 'BRIDGE_TIMEOUT');
  }

  function withTimeout(promise, ms) {
    var timeoutMs = ms == null ? BRIDGE_TIMEOUT_MS : ms;
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        var err = new Error('BRIDGE_TIMEOUT');
        reject(err);
      }, timeoutMs);
      Promise.resolve(promise).then(
        function (value) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(value);
        },
        function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function invalidateUserInfoCache() {
    _userInfoGen += 1;
    _userInfoCache = undefined;
    _userInfoInflight = null;
  }

  function summarizeUserInfo(user) {
    if (user == null) return { user: user };
    if (typeof user !== 'object') return { user: user, type: typeof user };
    var token = user.token != null ? String(user.token) : '';
    return {
      hasEmail: hasR66UserEmail(user),
      email: user.email != null ? user.email : null,
      uid: user.uid != null ? String(user.uid) : null,
      userId: user.userId != null ? String(user.userId) : null,
      id: user.id != null ? String(user.id) : null,
      tokenHead: token ? token.slice(0, 8) + '…' + token.length : null,
      switchIdentity: getR66SwitchIdentity(user),
      keys: Object.keys(user)
    };
  }

  /**
   * 进页预处理与点击共用同一份 getUserInfo。
   * force：绑完回来 / 换号后必须重新拉，避免把「无邮箱」缓存用到登录上。
   */
  function getBridgeUserInfo(opts) {
    var force = !!(opts && opts.force);
    // 真正重新打原生只靠 invalidateUserInfoCache。force 不能在缓存还在时再打一轮：
    // iOS/Android 同页第二次 getUserInfo 都经常没有回调，会空等到 5s。
    if (_userInfoCache !== undefined) {
      markBindEmailPerf('getUserInfo:cache', { elapsedMs: 0, hasEmail: hasR66UserEmail(_userInfoCache), force: force });
      authLog('getUserInfo', { via: 'cache', force: force, result: summarizeUserInfo(_userInfoCache) });
      return Promise.resolve(_userInfoCache);
    }
    // force 只跳过已落地的缓存；进行中的原生请求必须复用。
    // 首页 watch 与 autoLogin 若各打一轮 getUserInfo，原生常只回一次，自动登录会超时变游客。
    if (_userInfoInflight) {
      var joinAt = Date.now();
      markBindEmailPerf('getUserInfo:join-inflight', { force: force });
      authLog('getUserInfo', { via: 'join-inflight', force: force });
      return _userInfoInflight.then(
        function (user) {
          markBindEmailPerf('getUserInfo:inflight-resolved', {
            waitMs: Date.now() - joinAt,
            hasEmail: hasR66UserEmail(user)
          });
          authLog('getUserInfo', {
            via: 'inflight-resolved',
            force: force,
            waitMs: Date.now() - joinAt,
            result: summarizeUserInfo(user),
            raw: user
          });
          return user;
        },
        function (err) {
          markBindEmailPerf('getUserInfo:inflight-error', {
            waitMs: Date.now() - joinAt,
            err: String(err && err.message ? err.message : err)
          });
          authLog('getUserInfo', {
            via: 'inflight-error',
            force: force,
            waitMs: Date.now() - joinAt,
            err: String(err && err.message ? err.message : err)
          });
          throw err;
        }
      );
    }

    var bridge = window.AppWebBridge;
    if (!bridge || typeof bridge.getUserInfo !== 'function') {
      authLog('getUserInfo', { via: 'native', force: force, err: 'NO_BRIDGE' });
      return Promise.reject(new Error('NO_BRIDGE'));
    }

    var gen = _userInfoGen;
    var startedAt = Date.now();
    markBindEmailPerf('getUserInfo:native-start', { force: force });
    authLog('getUserInfo', { via: 'native-start', force: force, gen: gen });
    var pending = waitAfterNativeCall()
      .then(function () {
        return withTimeout(bridge.getUserInfo(), BRIDGE_TIMEOUT_MS);
      })
      .then(
      function (user) {
        markNativeCallSettled();
        var rawUser = user;
        user = normalizeBridgeUser(user);
        var elapsedMs = Date.now() - startedAt;
        var hasEmail = hasR66UserEmail(user);
        markBindEmailPerf('getUserInfo:native-return', {
          elapsedMs: elapsedMs,
          fromApp: true,
          timedOut: elapsedMs >= BRIDGE_TIMEOUT_MS - 20,
          hasEmail: hasEmail
        });
        authLog('getUserInfo', {
          via: 'native',
          force: force,
          elapsedMs: elapsedMs,
          gen: gen,
          genMatch: gen === _userInfoGen,
          result: summarizeUserInfo(user),
          raw: user,
          rawBeforeNormalize: rawUser !== user ? rawUser : undefined
        });
        if (gen === _userInfoGen) {
          _userInfoCache = user;
          _userInfoInflight = null;
        }
        return user;
      },
      function (err) {
        markNativeCallSettled();
        var elapsedMs = Date.now() - startedAt;
        markBindEmailPerf('getUserInfo:native-error', {
          elapsedMs: elapsedMs,
          fromApp: true,
          timedOut: isBridgeTimeout(err),
          err: String(err && err.message ? err.message : err)
        });
        authLog('getUserInfo', {
          via: 'native-error',
          force: force,
          elapsedMs: elapsedMs,
          gen: gen,
          timedOut: isBridgeTimeout(err),
          err: String(err && err.message ? err.message : err)
        });
        if (gen === _userInfoGen) {
          _userInfoInflight = null;
        }
        throw err;
      }
    );
    if (gen === _userInfoGen) {
      _userInfoInflight = pending;
    }
    return pending;
  }

  function hasR66GetUserInfo() {
    return !!(window.AppWebBridge && typeof window.AppWebBridge.getUserInfo === 'function');
  }

  /**
   * 档位：r66 / legacy。URL 无 apilevel 时会等 APP getAppInfo，可能卡到超时。
   * 点击 Buy Now / 结算不要等它；有 AppWebBridge.getUserInfo 就先走 R66。
   */
  function getProtocolTier() {
    var startedAt = Date.now();
    var via = 'sync-legacy';
    var pending;
    if (window.AppBridge && typeof window.AppBridge.getProtocolTierSync === 'function') {
      var cached = window.AppBridge.getProtocolTierSync();
      if (cached === 'r66' || cached === 'legacy') {
        markBindEmailPerf('getProtocolTier', {
          via: 'cache',
          tier: cached,
          elapsedMs: 0
        });
        return Promise.resolve(cached);
      }
    }
    if (window.AppBridge && typeof window.AppBridge.getProtocolTier === 'function') {
      via = 'AppBridge.getProtocolTier';
      pending = withTimeout(
        window.AppBridge.getProtocolTier().catch(function () {
          return 'legacy';
        }),
        BRIDGE_TIMEOUT_MS
      ).catch(function () {
        return 'legacy';
      });
    } else {
      pending = Promise.resolve('legacy');
    }
    return pending.then(function (tier) {
      markBindEmailPerf('getProtocolTier', {
        via: via,
        tier: tier,
        elapsedMs: Date.now() - startedAt
      });
      return tier;
    });
  }

  function normalizeBridgeUser(user) {
    if (user == null) return user;
    if (typeof user === 'string') {
      var trimmed = user.replace(/^\s+|\s+$/g, '');
      if (!trimmed) return user;
      try {
        user = JSON.parse(trimmed);
      } catch (e) {
        return user;
      }
    }
    if (!user || typeof user !== 'object') return user;
    var nested = user.data && typeof user.data === 'object' ? user.data : user.result;
    if (nested && typeof nested === 'object') {
      if (nested.email != null || nested.uid != null || nested.token != null || nested.id != null) {
        return nested;
      }
    }
    return user;
  }

  function hasR66UserEmail(user) {
    if (!user || typeof user !== 'object') return false;
    var email = user.email;
    if (typeof email !== 'string') return false;
    email = email.trim();
    if (!email || email === 'null' || email === 'undefined') return false;
    return true;
  }

  function isNotSupportErr(err) {
    if (err == null) return false;
    return String(err.message || err).indexOf('NOT_SUPPORT') !== -1;
  }

  function getR66UserIdentity(user) {
    if (!user || typeof user !== 'object') return '';
    if (user.uid != null && String(user.uid) !== '') return String(user.uid);
    if (user.userId != null && String(user.userId) !== '') return String(user.userId);
    if (user.id != null && String(user.id) !== '') return String(user.id);
    if (typeof user.email === 'string' && user.email.trim()) return user.email.trim();
    return '';
  }

  function getR66SwitchIdentity(user) {
    if (!user || typeof user !== 'object') return '';
    if (user.token != null && String(user.token) !== '') return String(user.token);
    return getR66UserIdentity(user);
  }

  var _shopifyLogoutStarted = false;

  var LOGOUT_PAINT_TIMEOUT_MS = 2000;
  var LOGOUT_TOAST_MS = 3000;
  var LOGOUT_GUEST_TOAST_FALLBACK =
    'Signed out because your app account has no email. Please add an email in the app.';

  function getLogoutGuestToastText() {
    var text = i18n.bind_email_logout_guest;
    if (typeof text === 'string') {
      text = text.trim();
      if (text && text.indexOf('bind_email_logout_guest') === -1) return text;
    }
    return LOGOUT_GUEST_TOAST_FALLBACK;
  }

  function showAuthToast(msg, duration, done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      if (typeof done === 'function') done();
    }

    if (!msg) {
      finish();
      return;
    }

    if (window.RoToast && typeof window.RoToast.show === 'function') {
      try {
        window.RoToast.show(msg, {
          duration: duration,
          placement: 'center',
          type: 'normal',
          onClose: finish,
        });
        setTimeout(finish, duration + 400);
        return;
      } catch (e) {}
    }

    var id = 'rr-mall-auth-toast';
    var existing = document.getElementById(id);
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    if (!document.getElementById('rr-mall-auth-toast-style')) {
      var style = document.createElement('style');
      style.id = 'rr-mall-auth-toast-style';
      style.textContent =
        '#rr-mall-auth-toast{display:inline-block;position:fixed;z-index:999999;top:50%;left:50%;right:auto;bottom:auto;width:auto;min-width:240px;max-width:min(320px,calc(100vw - 48px));height:auto;margin:0;padding:12px 16px;border:0;border-radius:4px;background:rgba(0,0,0,.90);box-shadow:0 4px 24px 0 rgba(0,0,0,.12);color:#fff;font-size:14px;font-weight:400;line-height:20px;text-align:center;white-space:normal;word-break:break-word;pointer-events:none;box-sizing:border-box;transform:translate(-50%,-50%);}' +
        '#rr-mall-auth-toast span{display:block;margin:0;padding:0;color:inherit;font:inherit;line-height:inherit;white-space:inherit;word-break:inherit;}';
      document.head.appendChild(style);
    }

    var el = document.createElement('div');
    el.id = id;
    el.setAttribute('role', 'status');
    var text = document.createElement('span');
    text.textContent = msg;
    el.appendChild(text);
    (document.body || document.documentElement).appendChild(el);
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
      finish();
    }, duration);
  }

  function waitForFirstPaint(done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      done();
    }
    function afterPaint() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          finish();
        });
      });
    }
    function afterDomReady() {
      // 让 layout 先去掉 body.invisible / .as-page-loading，再等两帧首绘
      setTimeout(afterPaint, 0);
    }
    setTimeout(finish, LOGOUT_PAINT_TIMEOUT_MS);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', afterDomReady);
      return;
    }
    afterDomReady();
  }

  function logoutShopifyAsGuest() {
    if (!getIsCustomer()) return;
    if (_shopifyLogoutStarted) return;
    var path = window.location.pathname || '/';
    if (path.indexOf('/account/logout') === 0) return;
    _shopifyLogoutStarted = true;
    var returnTo = path + (window.location.search || '');
    var url = '/account/logout';
    if (returnTo && returnTo.indexOf('/account/logout') !== 0) {
      url += '?return_to=' + encodeURIComponent(returnTo);
    }
    // if (isIosAppWebView()) {
      // window.location.href = url;
    waitForFirstPaint(function () {
      showAuthToast(getLogoutGuestToastText(), LOGOUT_TOAST_MS, function () {
        window.location.href = url;
      });
    });
    return;
    // }
    // window.location.replace(url);
  }

  function rememberR66SwitchIdentity(user) {
    var identity = getR66SwitchIdentity(user);
    if (identity) {
      try {
        localStorage.setItem(SWITCH_KEY, identity);
      } catch (e) {}
    }
    return identity;
  }

  function markR66PendingRelogin(change) {
    try {
      localStorage.setItem(PENDING_KEY, change ? '1' : '0');
    } catch (e) {}
    startPendingReloginPoll();
  }

  function clearR66PendingRelogin() {
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    stopPendingReloginPoll();
  }

  function stopPendingReloginPoll() {
    if (_pendingPollTimer) {
      clearTimeout(_pendingPollTimer);
      _pendingPollTimer = null;
    }
    _pendingPollUntil = 0;
  }

  function startPendingReloginPoll() {
    stopPendingReloginPoll();
    _pendingPollUntil = Date.now() + PENDING_POLL_MAX_MS;
    authLog('pending poll start', PENDING_POLL_MAX_MS + 'ms');
    function tick() {
      _pendingPollTimer = null;
      if (getIsCustomer() || !hasPendingRelogin()) {
        stopPendingReloginPoll();
        return;
      }
      if (Date.now() > _pendingPollUntil) {
        authLog('pending poll timeout, still guest');
        stopPendingReloginPoll();
        return;
      }
      if (_autoLoginInFlight || _mallTokenInflight || _mallLoginNavigating) {
        _pendingPollTimer = setTimeout(tick, PENDING_POLL_MS);
        return;
      }
      invalidateUserInfoCache();
      getBridgeUserInfo({ force: true }).then(
        function (user) {
          authLog('pending poll getUserInfo', {
            hasEmail: hasR66UserEmail(user),
            email: user && user.email
          });
          if (hasR66UserEmail(user)) {
            autoLoginIfHasEmail({ waitEmail: false, user: user });
          }
          if (!getIsCustomer() && hasPendingRelogin() && Date.now() < _pendingPollUntil) {
            _pendingPollTimer = setTimeout(tick, PENDING_POLL_MS);
          }
        },
        function (err) {
          authLog('pending poll getUserInfo err', String(err && err.message ? err.message : err));
          if (!getIsCustomer() && hasPendingRelogin() && Date.now() < _pendingPollUntil) {
            _pendingPollTimer = setTimeout(tick, PENDING_POLL_MS);
          }
        }
      );
    }
    _pendingPollTimer = setTimeout(tick, 400);
  }

  function isDismissCooldown() {
    try {
      var until = parseInt(localStorage.getItem(DISMISS_UNTIL_KEY), 10);
      return !isNaN(until) && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function markDismissCooldown() {
    try {
      localStorage.setItem(DISMISS_UNTIL_KEY, String(Date.now() + DISMISS_MS));
    } catch (e) {}
  }

  function clearDismissCooldown() {
    try {
      localStorage.removeItem(DISMISS_UNTIL_KEY);
    } catch (e) {}
  }

  function trackBindEmailDismiss() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'app_bind_email_close',
        event_parameters: {}
      });
    } catch (e) {}
  }

  function showBindEmailModal() {
    var modal = document.getElementById('app-bind-email-modal');
    if (!modal) {
      markBindEmailPerf('showBindEmailModal', { modalExists: false });
      finishBindEmailPerf('no-modal-dom');
      return;
    }
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('app-bind-email-modal-open');
    markBindEmailPerf('showBindEmailModal', { modalExists: true });
    finishBindEmailPerf('modal-shown');
  }

  function hideBindEmailModal() {
    var modal = document.getElementById('app-bind-email-modal');
    if (!modal) return;
    modal.setAttribute('hidden', 'hidden');
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('app-bind-email-modal-open');
  }

  function goToAccountLogin() {
    if (cfg.accountLoginUrl) {
      window.location.replace(cfg.accountLoginUrl);
    }
  }

  function openAppBindEmailRoute() {
    try {
      if (window.AppWebBridge && typeof window.AppWebBridge.routeBindEmail === 'function') {
        markBindEmailReturn();
        window.AppWebBridge.routeBindEmail();
        return true;
      }
    } catch (e) {
      clearBindEmailReturn();
      console.log('openAppBindEmailRoute', e);
    }
    return false;
  }

  function initBindEmailModal() {
    var modal = document.getElementById('app-bind-email-modal');
    if (!modal || _modalInited) return;
    _modalInited = true;
    var primary = document.getElementById('app-bind-email-modal-primary');
    if (primary) {
      primary.addEventListener('click', function () {
        if (typeof _bindHandler === 'function') _bindHandler();
      });
    }
    modal.querySelectorAll('[data-bind-email-dismiss]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (el.classList.contains('app-bind-email-modal__backdrop')) {
          trackBindEmailDismiss();
        }
        if (typeof _dismissHandler === 'function') _dismissHandler();
      });
    });
  }

  function getDismissUntil() {
    try {
      var until = parseInt(localStorage.getItem(DISMISS_UNTIL_KEY), 10);
      return isNaN(until) ? 0 : until;
    } catch (e) {
      return 0;
    }
  }

  /**
   * @param {string} mode 'guest' | 'account'
   * @returns {Promise<'dismissed'|'bound'|'ok'>}
   * dismissed = 本次关掉弹窗（结算不跳转）；ok = 已在冷却期内，结算放行
   */
  function promptBindEmail(mode) {
    initBindEmailModal();
    var wait;
    if (isDismissCooldown()) {
      markBindEmailPerf('skip-modal-cooldown');
      finishBindEmailPerf('cooldown');
      wait = Promise.resolve('ok');
    } else {
      wait = new Promise(function (resolve) {
        _dismissHandler = function () {
          markDismissCooldown();
          hideBindEmailModal();
          _dismissHandler = null;
          _bindHandler = null;
          resolve('dismissed');
        };
        _bindHandler = function () {
          hideBindEmailModal();
          markR66PendingRelogin(getIsCustomer());
          var ok = openAppBindEmailRoute();
          _dismissHandler = null;
          _bindHandler = null;
          if (!ok) {
            resolve('dismissed');
            return;
          }
          resolve('bound');
        };
        showBindEmailModal();
        if (!document.getElementById('app-bind-email-modal')) {
          resolve('ok');
        }
      });
    }
    return wait.then(function (result) {
      if (mode === 'account' && (result === 'dismissed' || result === 'ok')) {
        goToAccountLogin();
      }
      return result;
    });
  }

  function loginLogic(token, change) {
    if (!token) {
      return false;
    }
    var urlstring = 'https://' + window.location.hostname + '/account/login/multipass/' + token;
    if (getIsCustomer()) {
      if (change) {
        _mallLoginNavigating = true;
        window.location.replace(urlstring);
        return true;
      }
      return false;
    }
    _mallLoginNavigating = true;
    window.location.replace(urlstring);
    return true;
  }

  /**
   * 原生 getMallTokenV2：并发复用 inflight。
   * getUserInfo 刚回来时必须隔一拍再打，否则同页第二次协议经常不回调（BRIDGE_TIMEOUT）。
   */
  function requestMallTokenV2(bridge, mallId) {
    if (mallId == null || typeof bridge.getMallTokenV2 !== 'function') {
      return Promise.resolve(null);
    }
    return waitAfterNativeCall()
      .then(function () {
        return withTimeout(bridge.getMallTokenV2({ id: mallId, refresh: true }), BRIDGE_TIMEOUT_MS);
      })
      .then(
        function (res) {
          markNativeCallSettled();
          return extractMallLoginToken(res);
        },
        function (err) {
          markNativeCallSettled();
          throw err;
        }
      );
  }

  function fetchMallLoginToken() {
    if (_mallTokenInflight) {
      authLog('getMallToken', { via: 'join-inflight' });
      return _mallTokenInflight;
    }
    if (_mallLoginNavigating) {
      authLog('getMallToken', { via: 'skip-navigating' });
      return Promise.resolve(null);
    }
    var bridge = window.AppWebBridge;
    if (!bridge) return Promise.resolve(null);
    var resolved = resolveMallTokenId();
    var mallId = resolved.id;
    authLog('getMallToken', { id: mallId, source: resolved.source, via: 'native' });

    function tryFetch(left) {
      return requestMallTokenV2(bridge, mallId).catch(function (err) {
        if (!isBridgeTimeout(err) || left <= 0) throw err;
        authLog('getMallToken timeout, retry after settle', { left: left });
        return delay(NATIVE_SETTLE_MS).then(function () {
          return tryFetch(left - 1);
        });
      });
    }

    _mallTokenInflight = tryFetch(MALL_TOKEN_RETRY)
      .then(function (token) {
        if (token) return token;
        if (typeof bridge.getMallToken !== 'function') return null;
        authLog('getMallTokenV2 empty, fallback getMallToken');
        return waitAfterNativeCall()
          .then(function () {
            return withTimeout(bridge.getMallToken(), BRIDGE_TIMEOUT_MS);
          })
          .then(
            function (res2) {
              markNativeCallSettled();
              return extractMallLoginToken(res2);
            },
            function (err) {
              markNativeCallSettled();
              throw err;
            }
          );
      })
      .catch(function (err) {
        authLog('getMallToken err', String(err && err.message ? err.message : err));
        return null;
      })
      .then(function (token) {
        _mallTokenInflight = null;
        return token;
      });
    return _mallTokenInflight;
  }

  /**
   * Multipass 仅用 mall token。失败返回 false，不弹绑邮箱、不挡浏览。
   * 成功会 location.replace，调用方不必再往下走。
   */
  function loginWithR66MallToken(change) {
    if (!window.AppWebBridge) {
      authLog('login skip: no AppWebBridge');
      return Promise.resolve(false);
    }
    return fetchMallLoginToken().then(function (token) {
      if (token) {
        clearR66PendingRelogin();
        clearDismissCooldown();
        authLog('Multipass', { change: change || null });
        return loginLogic(token, change);
      }
      authLog('login skip: no mall token');
      hideMallLoginLoading();
      return false;
    });
  }

  function fetchLegacyMallToken() {
    if (_legacyTokenInflight) {
      authLog('getAppMallToken', { via: 'join-inflight' });
      return _legacyTokenInflight;
    }
    if (_mallLoginNavigating) return Promise.resolve(null);
    if (typeof getAppMallToken !== 'function') return Promise.resolve(null);
    authLog('getAppMallToken', { via: 'native' });
    _legacyTokenInflight = withTimeout(getAppMallToken(), BRIDGE_TIMEOUT_MS)
      .then(function (res) {
        return extractMallLoginToken(res);
      })
      .catch(function () {
        return null;
      })
      .then(function (token) {
        _legacyTokenInflight = null;
        return token;
      });
    return _legacyTokenInflight;
  }

  function tryLegacyLogin(change) {
    return fetchLegacyMallToken().then(function (token) {
      if (token) {
        loginLogic(token, change);
        return true;
      }
      return false;
    });
  }

  /**
   * 自动登录：有 email 才 Multipass；无 email / 失败 → false（游客）。
   * 不弹绑邮箱。绑完回来 waitEmail 时，原生可能尚未把 email 写回，短重试几次。
   */
  function getUserInfoUntilEmail(waitEmail) {
    function attempt(left) {
      return getBridgeUserInfo({ force: true }).then(
        function (user) {
          if (hasR66UserEmail(user) || !waitEmail || left <= 0) return user;
          invalidateUserInfoCache();
          return delay(BIND_EMAIL_RETRY_MS).then(function () {
            return attempt(left - 1);
          });
        },
        function (err) {
          if (
            !waitEmail ||
            left <= 0 ||
            isBridgeTimeout(err) ||
            isNotSupportErr(err)
          ) {
            throw err;
          }
          return delay(BIND_EMAIL_RETRY_MS).then(function () {
            return attempt(left - 1);
          });
        }
      );
    }
    return attempt(BIND_EMAIL_RETRY);
  }

  /**
   * R66 自动登录。返回：
   * true / false = 已按 email 结论处理（无邮箱绝不走 Legacy）
   * null = 协议不支持，可回落 Legacy
   */
  function tryR66AutoLogin(change, waitEmail, userHint) {
    var bridge = window.AppWebBridge;
    if (!bridge || typeof bridge.getUserInfo !== 'function') {
      return Promise.resolve(null);
    }
    if (_resumeFromBindEmail) showMallLoginLoading();
    var canUseHint = userHint && (!waitEmail || hasR66UserEmail(userHint));
    var pending = canUseHint ? Promise.resolve(userHint) : getUserInfoUntilEmail(waitEmail);
    return pending.then(
      function (user) {
        var hasEmail = hasR66UserEmail(user);
        if (!hasEmail) {
          hideBindEmailModal();
          hideMallLoginLoading();
          authLog('tryR66AutoLogin: no email', { change: change || null, waitEmail: !!waitEmail });
          if (change && getIsCustomer() && !waitEmail) {
            rememberR66SwitchIdentity(user);
            logoutShopifyAsGuest();
          } else if (!change) {
            rememberR66SwitchIdentity(user);
          }
          return false;
        }
        hideBindEmailModal();
        if (_resumeFromBindEmail) showMallLoginLoading();
        authLog('tryR66AutoLogin: has email, Multipass');
        return loginWithR66MallToken(change).then(function (ok) {
          if (ok) {
            rememberR66SwitchIdentity(user);
          } else {
            hideMallLoginLoading();
            if (!change) rememberR66SwitchIdentity(user);
            else authLog('switch Multipass failed, keep old SWITCH_KEY to retry');
          }
          return ok;
        });
      },
      function (err) {
        hideMallLoginLoading();
        if (isNotSupportErr(err)) return null;
        return false;
      }
    );
  }

  function tryAutoLogin(change, opts) {
    var waitEmail = !!(opts && opts.waitEmail);
    var userHint = opts && opts.user;
    return tryR66AutoLogin(change, waitEmail, userHint).then(function (result) {
      if (result !== null) return result;
      return getProtocolTier().then(function (tier) {
        if (tier === 'r66') return false;
        showMallLoginLoading();
        return tryLegacyLogin(change).then(function (ok) {
          if (!ok) hideMallLoginLoading();
          return ok;
        });
      });
    });
  }

  /**
   * 固定逻辑：确认有邮箱且还不是 Shopify customer → Multipass。
   * 已有 user 时直接用，不再打 getUserInfo。
   */
  function autoLoginIfHasEmail(opts) {
    if (getIsCustomer() || _autoLoginInFlight || _mallLoginNavigating) {
      return Promise.resolve();
    }
    var waitEmail = !!(opts && opts.waitEmail);
    var kickAccount = !!(opts && opts.kickAccount);
    var userHint = opts && opts.user;
    authLog('autoLoginIfHasEmail', { waitEmail: waitEmail, path: path, hasUserHint: !!userHint });
    _autoLoginInFlight = true;
    var loginOpts = {};
    if (waitEmail) loginOpts.waitEmail = true;
    if (userHint) loginOpts.user = userHint;
    return tryAutoLogin(null, loginOpts).then(
      function (ok) {
        _autoLoginInFlight = false;
        _resumeFromBindEmail = false;
        authLog('autoLoginIfHasEmail done', { ok: ok });
        if (!ok && kickAccount && isAccountLayout) goToAccountLogin();
        return ok;
      },
      function () {
        _autoLoginInFlight = false;
        _resumeFromBindEmail = false;
      }
    );
  }

  function retryR66PendingReloginIfNeeded() {
    try {
      if (_mallLoginNavigating || _mallTokenInflight) return;
      var pending = localStorage.getItem(PENDING_KEY);
      if (pending !== '0' && pending !== '1') return;
      if (_autoLoginInFlight) return;
      if (getIsCustomer()) {
        if (pending !== '1') return;
        _autoLoginInFlight = true;
        tryAutoLogin(1, { waitEmail: _resumeFromBindEmail }).then(
          function () {
            _autoLoginInFlight = false;
            _resumeFromBindEmail = false;
          },
          function () {
            _autoLoginInFlight = false;
            _resumeFromBindEmail = false;
          }
        );
        return;
      }
      autoLoginIfHasEmail({ waitEmail: _resumeFromBindEmail, kickAccount: true });
    } catch (e) {}
  }

  /**
   * 与 layout / app-index 一致：仅 /pages/app-store 显示底栏，其它页隐藏。
   * 去原生绑邮箱再回来不会整页重载，layout 那次 hideAppTabBar 不会再跑，须在回前台补一次。
   */
  function syncAppTabBar() {
    var hide = !isMallHomePath();
    try {
      if (window.AppBridge && typeof window.AppBridge.invoke === 'function') {
        window.AppBridge.invoke('hideAppTabBar', hide);
        return;
      }
    } catch (e) {}
    try {
      if (typeof hideAppTabBar === 'function') {
        hideAppTabBar(hide);
      }
    } catch (e2) {}
  }

  function markNeedResumeWatch() {
    if (!_resumeEventsReady) return;
    _needResumeWatch = true;
  }

  function armResumeWatch() {
    _resumeEventsReady = true;
  }

  function reinitNativeBridge() {
    try {
      if (window.AppWebBridge && typeof window.AppWebBridge.reinit === 'function') {
        window.AppWebBridge.reinit();
      }
    } catch (e) {}
  }

  function onWebViewResume() {
    if (_mallLoginNavigating) return;
    if (!_resumeEventsReady && !peekBindEmailReturn()) return;
    _needResumeWatch = false;
    var fromBind = beginBindEmailReturnIfNeeded();
    if (fromBind || hasPendingRelogin()) {
      syncAppTabBar();
    }
    if (_resumeTimer) clearTimeout(_resumeTimer);
    _resumeTimer = setTimeout(function () {
      _resumeTimer = null;
      if (_mallLoginNavigating) return;
      _watchFromResume = true;
      authLog('resume watch', { fromBind: !!_resumeFromBindEmail });
      // 首屏 getUserInfo / Multipass 还在飞时不要清缓存，否则会再打一轮原生
      if (_watchInFlight || _autoLoginInFlight || _mallTokenInflight) {
        _watchQueued = true;
        return;
      }
      reinitNativeBridge();
      invalidateUserInfoCache();
      watchAppUserInfoChange();
    }, 300);
  }

  function onAppUserInfoForReloginLegacy(res) {
    if (!res) return Promise.resolve();
    var appToken = localStorage.getItem('appToken');
    var nextToken = typeof res === 'object' && res.token != null ? res.token : res;
    if (nextToken == null || nextToken === '') return Promise.resolve();
    if (String(nextToken) !== String(appToken)) {
      localStorage.setItem('appToken', nextToken);
      if (getIsCustomer()) return tryAutoLogin(1);
    }
    return Promise.resolve();
  }

  function stopSwitchRecheck() {
    _switchRecheckLeft = 0;
    if (_switchRecheckTimer) {
      clearTimeout(_switchRecheckTimer);
      _switchRecheckTimer = null;
    }
  }

  function scheduleSwitchRecheck() {
    if (!isIosAppWebView() || !getIsCustomer()) return;
    if (_shopifyLogoutStarted || _autoLoginInFlight || _mallLoginNavigating) return;
    if (_switchRecheckLeft <= 0) return;
    if (_switchRecheckTimer) return;
    // 第一次已经拿到身份就不要再打一轮：iOS 原生常只回一次，第二次会空等到 5s 超时
    if (_userInfoCache && getR66SwitchIdentity(_userInfoCache)) return;
    _switchRecheckTimer = setTimeout(function () {
      _switchRecheckTimer = null;
      if (!getIsCustomer() || _shopifyLogoutStarted || _autoLoginInFlight || _mallLoginNavigating) {
        return;
      }
      _switchRecheckLeft -= 1;
      authLog('ios switch recheck', { left: _switchRecheckLeft });
      reinitNativeBridge();
      invalidateUserInfoCache();
      watchAppUserInfoChange();
    }, SWITCH_RECHECK_MS);
  }

  /**
   * 同一份 getUserInfo 上的决策（不再分开打原生）：
   * 1) 换号：身份变了且已是 customer → tryAutoLogin(1)（无邮箱则 logout）
   * 2) 有邮箱 → 自动登录：只要还是游客就 Multipass，不看是否换号
   */
  function onAppUserInfoForReloginR66(user) {
    if (!user) return Promise.resolve();

    var nextIdentity = getR66SwitchIdentity(user);
    var prev = null;
    try {
      prev = localStorage.getItem(SWITCH_KEY);
    } catch (e) {}
    var identityChanged =
      !!nextIdentity && prev != null && prev !== '' && String(nextIdentity) !== String(prev);
    // Shopify 已登录 + APP 确认无邮箱（有 uid/token）→ 当游客。
    // 不依赖 SWITCH_KEY 是否已更新；绑邮箱 pending 时不踢。
    var confirmedNoEmailGuest =
      getIsCustomer() &&
      !!nextIdentity &&
      !hasR66UserEmail(user) &&
      !hasPendingRelogin() &&
      !_resumeFromBindEmail;

    if ((identityChanged || confirmedNoEmailGuest) && getIsCustomer()) {
      _skipPendingRetry = true;
      stopSwitchRecheck();
      authLog('switch identity detected, Shopify still logged in', {
        prev: prev,
        next: nextIdentity,
        identityChanged: identityChanged,
        confirmedNoEmailGuest: confirmedNoEmailGuest
      });
      if (_autoLoginInFlight || _mallLoginNavigating) return Promise.resolve();
      _autoLoginInFlight = true;
      return tryAutoLogin(1, { user: user }).then(
        function (ok) {
          _autoLoginInFlight = false;
          authLog('switch relogin done', { ok: ok });
          return ok;
        },
        function () {
          _autoLoginInFlight = false;
        }
      );
    }

    if (nextIdentity) rememberR66SwitchIdentity(user);

    if (getIsCustomer()) return Promise.resolve();

    if (hasR66UserEmail(user)) {
      _skipPendingRetry = true;
      return autoLoginIfHasEmail({
        waitEmail: false,
        kickAccount: hasPendingRelogin(),
        user: user
      });
    }

    if (hasPendingRelogin()) {
      _skipPendingRetry = true;
      return autoLoginIfHasEmail({
        waitEmail: false,
        kickAccount: true,
        user: user
      });
    }

    return Promise.resolve();
  }

  function runLegacyAuth() {
    if (_mallLoginNavigating) return Promise.resolve();
    if (!getIsCustomer()) {
      showMallLoginLoading();
      return tryLegacyLogin(null).then(function (ok) {
        if (!ok) hideMallLoginLoading();
        return ok;
      });
    }
    if (typeof getUserInfo !== 'function') return Promise.resolve();
    return withTimeout(getUserInfo(), BRIDGE_TIMEOUT_MS).then(
      function (res) {
        return onAppUserInfoForReloginLegacy(res);
      },
      function () {}
    );
  }

  /**
   * 首页自动登录与换号对账的唯一入口。
   * 先 getUserInfo 一次，再按状态决定要不要 getMallTokenV2（也只一次）。
   */
  function watchAppUserInfoChange() {
    if (_mallLoginNavigating) return;
    beginBindEmailReturnIfNeeded();
    if (_watchInFlight) {
      _watchQueued = true;
      return;
    }
    _watchInFlight = true;

    function done() {
      _watchInFlight = false;
      if (_mallLoginNavigating) {
        _watchQueued = false;
        return;
      }
      if (_watchQueued) {
        _watchQueued = false;
        if (_mallTokenInflight) return;
        watchAppUserInfoChange();
        return;
      }
      if (!_skipPendingRetry) retryR66PendingReloginIfNeeded();
      _skipPendingRetry = false;
      _watchFromResume = false;
      if (!_autoLoginInFlight) _resumeFromBindEmail = false;
      // 首屏不在这里 arm：iOS pageshow/focus 会立刻再打一轮 getUserInfo。
      // boot 里 1500ms 的 armResumeWatch 才打开回前台监听。
      if (getIsCustomer() && !_shopifyLogoutStarted && !_autoLoginInFlight && !_mallLoginNavigating) {
        scheduleSwitchRecheck();
      }
      if (!getIsCustomer() && hasPendingRelogin() && !_autoLoginInFlight && !_mallLoginNavigating) {
        startPendingReloginPoll();
      }
    }

    var pending;
    if (hasR66GetUserInfo()) {
      var needWaitEmail = _resumeFromBindEmail || (hasPendingRelogin() && !getIsCustomer());
      authLog('syncAuth', {
        waitEmail: needWaitEmail,
        fromBind: !!_resumeFromBindEmail,
        pendingRelogin: hasPendingRelogin(),
        customer: getIsCustomer(),
        home: isMallHomePath()
      });
      var userPromise = needWaitEmail
        ? getUserInfoUntilEmail(true)
        : getBridgeUserInfo({ force: true }).catch(function (err) {
            if (!isBridgeTimeout(err)) throw err;
            authLog('getUserInfo timeout, retry after settle');
            invalidateUserInfoCache();
            return delay(NATIVE_SETTLE_MS).then(function () {
              return getBridgeUserInfo({ force: true });
            });
          });
      pending = userPromise.then(
        function (user) {
          return onAppUserInfoForReloginR66(user);
        },
        function (err) {
          if (isNotSupportErr(err)) return runLegacyAuth();
        }
      );
    } else {
      pending = runLegacyAuth();
    }
    pending.then(done, done);
  }

  /**
   * 结算 / Buy Now / 白名单。
   * 本次关掉弹窗 → dismissed，不跳结算；冷却期内再点 → ok，放行。
   * 去原生绑邮箱 → bound，不重放点击。
   */
  function ensureCheckoutReady() {
    if (getIsCustomer()) {
      finishBindEmailPerf('already-customer');
      return Promise.resolve('ok');
    }
    if (_checkoutGate) {
      markBindEmailPerf('join-inflight-gate');
      return _checkoutGate;
    }

    markBindEmailPerf('ensureCheckoutReady');

    function afterUserInfoOk(user) {
      rememberR66SwitchIdentity(user);
      if (hasR66UserEmail(user)) {
        markBindEmailPerf('has-email-skip-modal');
        if (_mallLoginNavigating) {
          finishBindEmailPerf('has-email-login');
          return 'ok';
        }
        return loginWithR66MallToken().then(function () {
          finishBindEmailPerf('has-email-login');
          return 'ok';
        });
      }
      markBindEmailPerf('promptBindEmail');
      return promptBindEmail('guest');
    }

    function afterUserInfoErr(err) {
      return getProtocolTier().then(function (tier) {
        if (tier === 'r66') {
          if (isBridgeTimeout(err)) {
            markBindEmailPerf('getUserInfo-timeout-prompt-modal');
            return promptBindEmail('guest');
          }
          finishBindEmailPerf('r66-userinfo-err-guest');
          return 'ok';
        }
        return tryLegacyLogin().then(function () {
          finishBindEmailPerf('legacy-after-userinfo-err');
          return 'ok';
        });
      });
    }

    var gate;
    if (hasR66GetUserInfo()) {
      markBindEmailPerf('skip-getProtocolTier', { reason: 'has AppWebBridge.getUserInfo' });
      gate = getBridgeUserInfo().then(afterUserInfoOk, afterUserInfoErr);
    } else {
      markBindEmailPerf('no-r66-getUserInfo', { fallback: 'legacy' });
      gate = tryLegacyLogin().then(function () {
        finishBindEmailPerf('legacy-login');
        return 'ok';
      });
    }

    _checkoutGate = gate.then(
      function (result) {
        _checkoutGate = null;
        return result;
      },
      function (err) {
        _checkoutGate = null;
        throw err;
      }
    );

    return _checkoutGate;
  }

  function ensureAccountReady() {
    if (getIsCustomer()) return Promise.resolve('ok');

    if (!hasR66GetUserInfo()) {
      return tryLegacyLogin().then(function (ok) {
        if (!ok) goToAccountLogin();
        return 'ok';
      });
    }

    return getBridgeUserInfo().then(
      function (user) {
        rememberR66SwitchIdentity(user);
        if (hasR66UserEmail(user)) {
          if (_mallLoginNavigating) return 'ok';
          return loginWithR66MallToken().then(function (ok) {
            if (!ok) goToAccountLogin();
            return 'ok';
          });
        }
        return promptBindEmail('account');
      },
      function () {
        goToAccountLogin();
        return 'ok';
      }
    );
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    if (el.closest('#app-bind-email-modal')) return null;
    var checkoutBtn = el.closest('#checkOutNow, button[name="checkout"]');
    if (checkoutBtn) return { type: 'click', node: checkoutBtn };
    var buyNow = el.closest('.ro-buy-now');
    if (buyNow) return { type: 'click', node: buyNow };
    var checkoutLink = el.closest('a.as-checkout-btn');
    if (checkoutLink) {
      if (checkoutLink.id === 'show-score-mark') return null;
      var href = checkoutLink.getAttribute('href') || '';
      if (href.indexOf('/cart/') !== -1 || href.indexOf('/checkout') !== -1) {
        return { type: 'link', node: checkoutLink, href: checkoutLink.href };
      }
    }
    return null;
  }

  function checkoutTriggerLabel(trigger) {
    if (!trigger || !trigger.node) return 'checkout';
    var node = trigger.node;
    if (node.closest) {
      if (node.closest('#checkOutNow, button[name="checkout"]')) return 'cart-checkout';
      if (node.closest('.ro-buy-now')) return 'pdp-buyNow';
      if (node.closest('a.as-checkout-btn')) return 'pdp-buyNow';
    }
    return 'checkout';
  }

  function replayTrigger(trigger) {
    _allowOnce = true;
    try {
      if (trigger.type === 'link' && trigger.href) {
        window.location.href = trigger.href;
        return;
      }
      if (trigger.node && typeof trigger.node.click === 'function') {
        trigger.node.click();
      }
    } finally {
      setTimeout(function () {
        _allowOnce = false;
      }, 0);
    }
  }

  function bindCheckoutInterceptors() {
    document.addEventListener(
      'click',
      function (event) {
        if (_allowOnce) return;
        var trigger = isCheckoutTrigger(event.target);
        if (!trigger) return;
        startBindEmailPerf(checkoutTriggerLabel(trigger));
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        ensureCheckoutReady().then(
          function (result) {
            if (_bindEmailPerf) finishBindEmailPerf(result);
            if (result === 'bound' || result === 'dismissed') return;
            replayTrigger(trigger);
          },
          function () {
            finishBindEmailPerf('error');
            replayTrigger(trigger);
          }
        );
      },
      true
    );
  }

  function autoLoginOnHome() {
    if (getIsCustomer()) return Promise.resolve(false);
    beginBindEmailReturnIfNeeded();
    watchAppUserInfoChange();
    return Promise.resolve(false);
  }

  function boot() {
    if (window.__RR_APP_PAGES_STATIC__) return;
    if (!isAppWebView()) return;

    try {
      localStorage.removeItem('__rr_mock_no_email__');
    } catch (e) {}

    installGetUserInfoMock();

    initBindEmailModal();
    resolveMallTokenId();

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        markNeedResumeWatch();
        return;
      }
      if (document.visibilityState === 'visible') onWebViewResume();
    });
    window.addEventListener('pagehide', function () {
      markNeedResumeWatch();
    });
    window.addEventListener('blur', function () {
      markNeedResumeWatch();
    });
    window.addEventListener('pageshow', function (event) {
      if ((event && event.persisted) || _needResumeWatch || peekBindEmailReturn()) {
        onWebViewResume();
      }
    });
    window.addEventListener('focus', function () {
      if (_needResumeWatch || peekBindEmailReturn()) onWebViewResume();
    });

    setTimeout(armResumeWatch, 1500);

    if (isIosAppWebView() && getIsCustomer()) {
      _switchRecheckLeft = SWITCH_RECHECK_MAX;
    }

    bindCheckoutInterceptors();

    beginBindEmailReturnIfNeeded();

    if (isAccountLayout && !getIsCustomer()) {
      ensureAccountReady().then(
        function () {
          watchAppUserInfoChange();
        },
        function () {
          watchAppUserInfoChange();
        }
      );
      return;
    }

    watchAppUserInfoChange();

    if (!isMallHomePath() && !getIsCustomer() && pathMatchesWhitelist()) {
      ensureCheckoutReady();
    }
  }

  window.AppMallAuth = {
    autoLoginOnHome: autoLoginOnHome,
    ensureCheckoutReady: ensureCheckoutReady,
    ensureAccountReady: ensureAccountReady,
    tryAutoLogin: tryAutoLogin,
    loginWithR66MallToken: loginWithR66MallToken,
    resolveMallTokenId: resolveMallTokenId,
    hasR66UserEmail: hasR66UserEmail,
    showBindEmailModal: showBindEmailModal,
    hideBindEmailModal: hideBindEmailModal,
    isMockNoEmail: isMockNoEmail,
    clearBindEmailDismiss: clearDismissCooldown,
    getBindEmailDismissUntil: getDismissUntil
  };

  installGetUserInfoMock();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
